const ConnectorsTableParser = {};

ConnectorsTableParser.getConnectorsTableParser = (res) => {
  if (res) {
    res = res?.result?.reverse();
  }

  if (!res) {
    return {};
  }
};

export { ConnectorsTableParser };
